import DialogAlertErrorSimple from "components/DialogAlertErrorSimple/v2";

const DialogErrorForFutureReservationsInDeletion = ({ dialog }) => {
	return (
		<DialogAlertErrorSimple
			dialog={dialog}
			title="No se puede eliminar el recurso"
			content="Actualmente el recurso cuenta con reservas, para eliminarlo, debes validar que no exista ninguna reserva vigente o futura." />
	);
}

export default DialogErrorForFutureReservationsInDeletion;